module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Introduction"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book deals with the decisive first few weeks of the invasion of Normandy in 1944. It therefore covers an important, perhaps even the most important, part of World War II. As was the case with Stalingrad in 1943, Falaise was the tragic turning point for an entire front.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Events are described from the point of view of the chief of the intelligence section of the headquarters of the LXXXIV Army Corps. The book details how the fighting unfolded – mainly against the Americans – and how it came to be that our troops were defeated. It serves also as a commemorative volume for our old comrades in the army corps, and especially for those who fell on the battlefield. Their fate may be overshadowed by the events, yet it was those very men who played a role in shaping those events.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I dedicate this book to the brave soldiers on both sides and to those who sacrificed themselves in battle. I dedicate it to my two sons, Dieter and Hartmuth, both born in 1927. Dieter was declared missing in action near Potsdam, while Hartmuth was killed in action at Fortress Courbière in Graudenz. Many parents likewise lost their sons in the war, so this book is dedicated to them as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several fellow combatants are deserving of my warm thanks. They read this work in whole or in part, provided me access to unpublished reports or accounts, and offered valuable help and criticism. I thank General of Panzer Troops Heinrich Eberbach, Lieutenant-General Paul Mahlmann, Major-General Rudolf-Christoph Freiherr von Gersdorff, Colonel Wilhelm Meyer-Detring, Lieutenant-Colonel Friedrich von Criegern, Lieutenant-Colonel Günther Keil, and Captain Wilhelm Ritter von Schramm.")]), _vm._v(" "), _c('p', {
    staticClass: "rightt"
  }, [_vm._v("Bordesholm, Holstein, on 6 June 1954")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Friedrich Hayn")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "map1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ix-01.jpg",
      "width": "80%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 1: France on 6 June 1944")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e24bce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Introduction.vue
// module id = 75
// module chunks = 0